import Vue from 'vue';
import JsEncrypt from 'jsencrypt';

Vue.prototype.$encruption = function (obj) {
  var encrypt = new JsEncrypt();
  encrypt.setPublicKey("-----BEGIN PUBLIC KEY-----" + "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhF4hwxOACZp4spo7tGltX7NfQZED1XkQgNxhoyczkJ06PtFlcTH+cJ5zJBkDOBLEFTyovuvc15xpPgwemT1e8DVns5fAS5TIIiw6s7On98re+veXNeQPtz6tdIlviTuCQ4oW9+kumIr/4agPK/LQ4LQi6k/ymkZltQtwp1SRwkZo13fRen/WfYWS/K11w8DepETWFr6HL/CK8IlPJgPnOWqmb/T5vJ75uoNOylzL/t2b9s/+oY7GtewVtgR0tJS3x+59DCb6CqIWl7ace5WcLKhBQqyEjgfA1aKfitJYai8XU2O/SI3ik2leY1WZrbNv6/lI/6AcFs1tbrHlrk+LkQIDAQAB" + "-----END PUBLIC KEY-----");
  return encrypt.encrypt(obj);
};